<div class="select-banner">
  <div class="select-banner__header">
    <div class="select-banner__icon">
      <mat-icon>info</mat-icon>
    </div>
    <div class="select-banner__title" *ngIf="!linkAllItems">
      {{ 'INFO_BANNER.LABEL' | translate }}
    </div>
    <div class="select-banner__label" (click)="selectAllItems()" *ngIf="!linkAllItems">
      {{ 'INFO_BANNER.SELECT_ALL' | translate: { totalItems: totalItems } }}
    </div>
    <span class="select-banner__title" *ngIf="linkAllItems">
      {{ 'INFO_BANNER.ALL_SELECTED' | translate: { totalItems: totalItems } }}
    </span>
  </div>
</div>
